module.exports = __webpack_public_path__ + "img/logoTruck_mini.a4946f43.png";